import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import Shop from "@/pages/Shop";

export default function Collection() {
  const { slug } = useParams();
  const [cat, setCat] = useState(null);

  useEffect(() => {
    api.get("/categories").then((r) => {
      setCat(r.data.find((c) => c.slug === slug) || { slug, name: slug, tagline: "" });
    });
  }, [slug]);

  return (
    <div data-testid="collection-page">
      {cat && (
        <section className="relative bg-nude border-b border-stone-line">
          <div className="grid lg:grid-cols-2">
            <div className="px-6 lg:px-16 py-16 lg:py-24 flex flex-col justify-center">
              <p className="small-label text-gold">Collection</p>
              <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-3">{cat.name}</h1>
              <p className="text-stone mt-4 max-w-md">{cat.tagline}</p>
            </div>
            <div className="aspect-[4/3] lg:aspect-auto relative">
              {cat.image && (
                <img src={cat.image} alt={cat.name} className="absolute inset-0 w-full h-full object-cover" />
              )}
            </div>
          </div>
        </section>
      )}
      <Shop presetCategory={slug} />
    </div>
  );
}
